import { type FC, type ReactNode } from 'react';

import styles from './ContentWrapper.scss';
import classNames from 'classnames';

type Props = {
    vertical?: boolean;
    fullOpacity?: boolean;
    children: ReactNode;
};

const ContentWrapper: FC<Props> = ({ children, vertical, fullOpacity, ...props }) => (
    <div
        {...props}
        className={classNames(styles.contentWrapper, {
            [styles.vertical]: vertical,
            [styles.fullOpacity]: fullOpacity,
        })}
    >
        {children}
    </div>
);

export default ContentWrapper;
